'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ForgotPasswordDialog = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, authActions), null, { withRef: true }), _dec2 = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ForgotPasswordDialog, _Component);

  function ForgotPasswordDialog() {
    (0, _classCallCheck3.default)(this, ForgotPasswordDialog);
    return (0, _possibleConstructorReturn3.default)(this, (ForgotPasswordDialog.__proto__ || (0, _getPrototypeOf2.default)(ForgotPasswordDialog)).apply(this, arguments));
  }

  (0, _createClass3.default)(ForgotPasswordDialog, [{
    key: 'open',
    value: function open() {
      this.modal.open();
    }
  }, {
    key: 'close',
    value: function close() {
      this.modal.close();
    }
  }, {
    key: 'afterSet',
    value: function afterSet() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props = this.props,
          t = _props.t,
          login = _props.login;

      this.close();
      _toastr2.default.success(t('Password successfully created'));
      login(data.email, data.newPassword);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          t = _props2.t,
          passwordCode = _props2.passwordCode,
          passwordEmail = _props2.passwordEmail,
          passwordKey = _props2.passwordKey,
          isNew = _props2.isNew,
          step = _props2.step;

      var modalProps = {
        backdrop: 'static',
        closeByEsc: false,
        title: passwordCode ? isNew ? t('Create password') : t('New password') : t('Forgot password')
      };

      return _react2.default.createElement(
        _components.Modal,
        (0, _extends3.default)({ ref: function ref(el) {
            return _this2.modal = el;
          } }, modalProps),
        _react2.default.createElement(_components.ForgotPasswordForm, {
          passwordCode: passwordCode,
          passwordEmail: passwordEmail,
          passwordKey: passwordKey,
          isNew: isNew,
          step: step,
          afterSet: this.afterSet
        })
      );
    }
  }]);
  return ForgotPasswordDialog;
}(_react.Component), _class3.propTypes = {
  isNew: _propTypes2.default.bool,
  login: _propTypes2.default.func,
  passwordCode: _propTypes2.default.string,
  passwordEmail: _propTypes2.default.string,
  passwordKey: _propTypes2.default.string,
  step: _propTypes2.default.string,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'afterSet', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'afterSet'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = ForgotPasswordDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ForgotPassword/ForgotPasswordDialog.js
// module id = 2158
// module chunks = 1